import { render, staticRenderFns } from "./todo.vue?vue&type=template&id=1d2a408f&"
import script from "./todo.vue?vue&type=script&lang=babel&"
export * from "./todo.vue?vue&type=script&lang=babel&"
import style0 from "./todo.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
